// extracted by mini-css-extract-plugin
export default {"lottieContainer":"styles_lottieContainer__+-dI8"};